import type { FormStepper } from '@paid-ui/types/form';

import { SignUpStep } from '../models/enums';

export const signUpSteps: FormStepper<SignUpStep>[] = [
  {
    index: SignUpStep.TYPE_AND_EMAIL,
    title: 'Sign up free.',
    fields: ['type', 'email', 'agreedOnTerms'],
  },
  {
    index: SignUpStep.OWNER_TYPE,
    title: 'Do you have a business?',
    fields: ['ownerType'],
  },
  {
    index: SignUpStep.OWNER_DETAILS,
    title: 'Welcome to Paid.',
    description: 'As a property owner how would you like to be added as a party to contracts?',
    fields: ['firstName', 'lastName', 'mobile', 'password', 'agreedOnTerms'],
  },
  {
    index: SignUpStep.OWNER_CONFIRM,
    title: "You're joining as an individual.",
    description:
      "You've been invited to join Paid as a business. Switching to join as an individual sets how you're represented on contracts and can't be changed later.",
    fields: [],
  },
  {
    index: SignUpStep.BUSINESS_STRUCTURE,
    title: 'Tell us about your business.',
    fields: ['structure'],
  },
  {
    index: SignUpStep.BUSINESS_ABN,
    title: 'Do you have an ABN?',
    fields: ['abn'],
  },
  {
    index: SignUpStep.BUSINESS_DETAILS,
    title: 'Tell us about your business and role.',
    fields: ['businessName', 'roleInBusiness'],
  },
  {
    index: SignUpStep.BUSINESS_COMPANY_DETAILS,
    title: 'Tell us about your company and role.',
    fields: ['companyName', 'acn', 'roleInCompany'],
  },
  {
    index: SignUpStep.TRUSTEE_DETAILS,
    title: 'Tell us about your role as trustee.',
    fields: ['companyName', 'acn', 'roleInTrust'],
  },
  {
    index: SignUpStep.TRUSTEE_COMPANY_DETAILS,
    title: 'Tell us about your trustee company and role.',
    fields: ['companyName', 'acn', 'roleInCompany'],
  },
  {
    index: SignUpStep.USER_DETAILS,
    title: "Let's get more of your details to complete sign up.",
    fields: ['firstName', 'lastName', 'mobile', 'password', 'agreedOnTerms'],
  },
  {
    index: SignUpStep.ONE_TIME_CODE,
    title: 'Enter your one time code to continue.',
    description: "We've just send a code to",
    fields: ['oneTimeCode'],
  },
  {
    index: SignUpStep.CHANGE_EMAIL,
    title: 'Edit email address',
    fields: ['email'],
  },
  {
    index: SignUpStep.CREATE_CONTRACT,
    title: "Congratulations. Let's start getting you paid.",
    description: 'Create your first contract to secure all your payments.',
    fields: [],
  },
  {
    index: SignUpStep.COMPLETE_CONTRACT,
    title: "You've signed up!",
    description: 'Continue to join your first contract on Paid.',
    fields: [],
  },
  {
    index: SignUpStep.REVIEW_CONTRACT,
    title: "Congratulations. Let's start getting you paid.",
    description: 'Now you can review the contract you were invited to.',
    fields: [],
  },
  {
    index: SignUpStep.SIGN_CONTRACT,
    title: "You've signed up!",
    description: 'Continue to sign your first contract on Paid.',
    fields: [],
  },
  {
    index: SignUpStep.OWNER_INVITE_BUILDER,
    title: "We can't sign you up at this time.",
    description:
      "If you are building a new home, we can ask the builder to sign up and invite you. Please enter the builder's email below.",
    fields: ['inviterName', 'inviteeEmail', 'inviteJoinReason'],
  },
  {
    index: SignUpStep.EMPLOYEE_INVITE_DIRECTOR,
    title: "We can't sign you up at this time.",
    description:
      "To start using Paid, please get an owner of your business to sign-up initially. We'll let you know when you can join Paid too.",
    fields: ['inviterName', 'inviteeEmail', 'inviteJoinReason'],
  },
  {
    index: SignUpStep.EMPLOYEE_INVITE_PARTNER,
    title: "We can't sign you up at this time.",
    description:
      "To start using Paid, please get an owner of your business to sign-up initially. We'll let you know when you can join Paid too.",
    fields: ['inviterName', 'inviteeEmail', 'inviteJoinReason'],
  },
  {
    index: SignUpStep.EMPLOYEE_INVITE_SOLE_TRADER,
    title: "We can't sign you up at this time.",
    description:
      "To start using Paid, please get an owner of your business to sign-up initially. We'll let you know when you can join Paid too.",
    fields: ['inviterName', 'inviteeEmail', 'inviteJoinReason'],
  },
  {
    index: SignUpStep.EMPLOYEE_INVITE_TRUSTEE,
    title: "We can't sign you up at this time.",
    description:
      "To start using Paid, please get a Director of your trustee company to sign-up initially. We'll let you know when you can join Paid too.",
    fields: ['inviterName', 'inviteeEmail', 'inviteJoinReason'],
  },
];
